import { createSafeContext } from '@mantine/utils';

const [DrawerProvider, useDrawerContext] = createSafeContext("Drawer component was not found in tree");

export { DrawerProvider, useDrawerContext };
//# sourceMappingURL=Drawer.context.js.map
